import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            八大分类，精准找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="font-heading font-bold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap text-sm">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">
                海量资源 每日更新
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}